// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.turing-ui-v2-section {
  background: #fff;
  padding: 30px;
  margin-bottom: 30px;
  border-radius: 9px;
  box-shadow: 0 1px 9px #e8e8e8;
}

.turing-ui-v2-section-separator {
  margin: 30px -30px;
  height: 2px;
  background: #f3f3f3;
}

.turing-ui-v2-section-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.turing-ui-v2-section-title {
  font-size: 1rem;
  margin: 15px 0;
  color: #999;
}

.turing-ui-v2-section h2 {
  font-size: 1.3rem;
  margin-bottom: 20px;
  font-weight: inherit;
  font-weight: 500;
  letter-spacing: -0.3px;
}

.turing-ui-v2-section-grid {
  display: grid;
  grid-gap: 15px;
  grid-auto-flow: column;
}

.turing-ui-v2-section-inline-grid {
    display: -moz-inline-grid;
    display: -ms-inline-grid;
    display: inline-grid;
    grid-gap: 15px;
    grid-auto-flow: column;
  }

.turing-ui-v2-section-dot {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  font-size: 12px;
}

.turing-ui-v2-section-dot > span {
  padding: 5px;
  border-radius: 50%;
  background: #999;
  color: #fff;
  width: 22px;
  height: 22px;
  font-size: 10px;
  display: flex;
  justify-content: center;
}

.turing-ui-v2-section-dot > * + * {
  flex: 1;
  margin-left: 15px;
}

.turing-ui-v2-section .ant-btn.ant-btn-link {
  padding-top: 8px;
}

.turing-ui-v2-section-editable {
  display: flex;
  margin: 20px 0;
}
.turing-ui-v2-section-editable > .turing-ui-v2-section-editable-content {
  flex: 1;
  display: flex;
  padding-right: 15px;
}
.turing-ui-v2-section-editable > .turing-ui-v2-section-editable-content > * + * {
    margin-left: 15px;
    flex: 1;
}
.turing-ui-v2-section-editable > .turing-ui-v2-section-editable-btn {
  opacity: 0.5;
}
.turing-ui-v2-section-info {
  display: flex;
  align-items: flex-start;
  margin: 10px;
}
.turing-ui-v2-section-info > * + * {
  margin-left: 10px;
  flex: 1;
}

.turing-ui-v2-section-info-content{
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fadeInAndOut {
  -webkit-animation: fadeinout 6s linear forwards infinite;
  animation: fadeinout 6s linear forwards infinite;
  display: inline-block;
}

.hidden {
  display: none;
}

.floatInline {
  clear: left;
  margin-top: -5px !important;
}

.sectionTitle {
  /* float: left; */
  margin-right: 10px;
}

@-webkit-keyframes fadeinout {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

@keyframes fadeinout {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

.turing-ui-v2-section-bg {
  background: transparent linear-gradient(76deg, var(--indigo) 0%, var(--blue) 100%) 0% 0% no-repeat padding-box;
  background: transparent linear-gradient(76deg, #6C7BD4 0%, #56A8F7 100%) 0% 0% no-repeat padding-box;
  color: #fff;
}

.turing-ui-v2-section-bg button {
  color: #fff;
}
 `, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/section/Section.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,oBAAoB;IACpB,cAAc;IACd,sBAAsB;EACxB;;AAEF;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;AACrB;AACA;IACI,iBAAiB;IACjB,OAAO;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wDAAwD;EACxD,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,8GAA8G;EAC9G,oGAAoG;EACpG,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":[".turing-ui-v2-section {\n  background: #fff;\n  padding: 30px;\n  margin-bottom: 30px;\n  border-radius: 9px;\n  box-shadow: 0 1px 9px #e8e8e8;\n}\n\n.turing-ui-v2-section-separator {\n  margin: 30px -30px;\n  height: 2px;\n  background: #f3f3f3;\n}\n\n.turing-ui-v2-section-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.turing-ui-v2-section-title {\n  font-size: 1rem;\n  margin: 15px 0;\n  color: #999;\n}\n\n.turing-ui-v2-section h2 {\n  font-size: 1.3rem;\n  margin-bottom: 20px;\n  font-weight: inherit;\n  font-weight: 500;\n  letter-spacing: -0.3px;\n}\n\n.turing-ui-v2-section-grid {\n  display: grid;\n  grid-gap: 15px;\n  grid-auto-flow: column;\n}\n\n.turing-ui-v2-section-inline-grid {\n    display: -moz-inline-grid;\n    display: -ms-inline-grid;\n    display: inline-grid;\n    grid-gap: 15px;\n    grid-auto-flow: column;\n  }\n\n.turing-ui-v2-section-dot {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 15px;\n  font-size: 12px;\n}\n\n.turing-ui-v2-section-dot > span {\n  padding: 5px;\n  border-radius: 50%;\n  background: #999;\n  color: #fff;\n  width: 22px;\n  height: 22px;\n  font-size: 10px;\n  display: flex;\n  justify-content: center;\n}\n\n.turing-ui-v2-section-dot > * + * {\n  flex: 1;\n  margin-left: 15px;\n}\n\n.turing-ui-v2-section .ant-btn.ant-btn-link {\n  padding-top: 8px;\n}\n\n.turing-ui-v2-section-editable {\n  display: flex;\n  margin: 20px 0;\n}\n.turing-ui-v2-section-editable > .turing-ui-v2-section-editable-content {\n  flex: 1;\n  display: flex;\n  padding-right: 15px;\n}\n.turing-ui-v2-section-editable > .turing-ui-v2-section-editable-content > * + * {\n    margin-left: 15px;\n    flex: 1;\n}\n.turing-ui-v2-section-editable > .turing-ui-v2-section-editable-btn {\n  opacity: 0.5;\n}\n.turing-ui-v2-section-info {\n  display: flex;\n  align-items: flex-start;\n  margin: 10px;\n}\n.turing-ui-v2-section-info > * + * {\n  margin-left: 10px;\n  flex: 1;\n}\n\n.turing-ui-v2-section-info-content{\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.fadeInAndOut {\n  -webkit-animation: fadeinout 6s linear forwards infinite;\n  animation: fadeinout 6s linear forwards infinite;\n  display: inline-block;\n}\n\n.hidden {\n  display: none;\n}\n\n.floatInline {\n  clear: left;\n  margin-top: -5px !important;\n}\n\n.sectionTitle {\n  /* float: left; */\n  margin-right: 10px;\n}\n\n@-webkit-keyframes fadeinout {\n  10%, 90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n\n  20%, 80% {\n    transform: translate3d(2px, 0, 0);\n  }\n\n  30%, 50%, 70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n\n  40%, 60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n\n@keyframes fadeinout {\n  10%, 90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n\n  20%, 80% {\n    transform: translate3d(2px, 0, 0);\n  }\n\n  30%, 50%, 70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n\n  40%, 60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n\n.turing-ui-v2-section-bg {\n  background: transparent linear-gradient(76deg, var(--indigo) 0%, var(--blue) 100%) 0% 0% no-repeat padding-box;\n  background: transparent linear-gradient(76deg, #6C7BD4 0%, #56A8F7 100%) 0% 0% no-repeat padding-box;\n  color: #fff;\n}\n\n.turing-ui-v2-section-bg button {\n  color: #fff;\n}\n "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
